// 2-tier only: Vietnam's 2025 reform abolished the district (Quận/Huyện) level. Static dataset (assets/data/vn-address.json), no live API.
function populateSelect(select, items, placeholder) {
	select.innerHTML = '';

	const placeholderOption = document.createElement('option');
	placeholderOption.value = '';
	placeholderOption.textContent = placeholder;
	select.appendChild(placeholderOption);

	items.forEach((item) => {
		const option = document.createElement('option');
		option.value = item.code;
		option.textContent = item.name;
		select.appendChild(option);
	});

	select.disabled = items.length === 0;
}

document.addEventListener('DOMContentLoaded', () => {
	const provinceSelect = document.getElementById('checkout-province');
	if (!provinceSelect) {
		return;
	}

	const wardSelect = document.getElementById('checkout-ward');

	fetch(provinceSelect.dataset.addressUrl)
		.then((res) => res.json())
		.then((tree) => {
			populateSelect(provinceSelect, tree, 'Chọn Tỉnh/Thành phố');

			provinceSelect.addEventListener('change', () => {
				const province = tree.find((p) => p.code === provinceSelect.value);
				populateSelect(wardSelect, province ? province.wards : [], 'Chọn Phường/Xã');
			});
		});
});
